<template>
  <div class="comparison-root">
    <transition name="compare-slide-right">
      <aside v-if="!isCollapsed" class="comparison-panel">
        <header class="comparison-header" style="background-color: #DFEEFF;">
          <span class="title">
            对比栏
          </span>
          <span class="actions">
            <a
              class="compare-btn"
              href="javascript:;"
              @click.stop="toggleComparison"
              style=" 
                font-size: 12px;
                background-color: #FFFFFF;
                color: #000;
                border: 1px solid #D9D9D9;
                "
            >隐藏</a>
            <a
              class="compare-btn"
              href="javascript:;"
              @click.stop="goCompare"
              style="
                font-size: 12px;
                background-color: #2655AE;
                color: #FFFFFF;
                border: 1px solid #2655AE;
                "
            >对比</a>
          </span>
        </header>
        <div class="comparison-line" style="height: 35px;line-height: 35px;font-size: 12px; padding: 0 8px;color: #000;">
          已添加
          <span v-if="compareList.length > 0" class="count" style="color: #2655AE;">{{ compareList.length }}</span>
          <span v-else class="count">0</span>
          项产品
          <a
              class="clear-btn"
              href="javascript:;"
              @click.stop="clearAll" style="float: right;"
              :style="{ color: compareList.length === 0 ? '#999999' : '' }"
            >清空</a>
        </div>
        <div class="comparison-body">
          <template v-if="compareList.length > 0">
            <div
              v-for="item in compareList"
              :key="item.id"
              class="comparison-item"
            >
              <div class="item-img" @click="gotoDetail(item)">
                <img :src="item.pic" alt="">
              </div>
              <div class="item-info">
                <p class="item-name" :title="item.name" @click="gotoDetail(item)">
                  {{ item.name }}
                </p>
                <p class="item-desc" :title="item.parameterStr">{{ item.parameterStr }}</p>
                <p class="item-price" :title="'￥' + item.price" >￥{{ item.price }}</p>
              </div>
              <img src="/static/icon/remove.svg" alt="" class="item-remove"
               @click="removeItem(item.id)"
               style="width: 16px;height: 16px;"
               >
            </div>
          </template>
          <div v-else class="no-item">
            <img src="/static/404/duibi.png" alt="" >
            <p>请添加需要对比的产品</p>
            <br>
            <p @click="gotoSearch" style="cursor: pointer; color: #FBB113;">去添加</p>
          </div>
        </div>
      </aside>
    </transition>
    
    <!-- 收起后的打开按钮 -->
    <div v-if="isCollapsed" class="comparison-collapsed" @click="toggleComparison">
      <span>打开对比栏</span>
    </div>
    <confirm-dialog
      :visible="showConfirm"
      message="是否删除产品？"
      confirm-text="删除"
      cancel-text="取消"
      @cancel="showConfirm = false"
      @confirm="confirmRemove"
    />
    <confirm-dialog
      :visible="showConfirmClear"
      message="是否清空所有对比产品？"
      confirm-text="清空"
      cancel-text="取消"
      @cancel="showConfirmClear = false"
      @confirm="confirmClear"
    />
    <confirm-dialog
      :visible="showConfirmCompare"
      message="请至少选择 2 件产品进行对比！"
      confirm-text=""
      cancel-text="我知道了"
      @cancel="showConfirmCompare = false"
      @confirm="showConfirmCompare = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ConfirmDialog from "../common/ConfirmDialog.vue";

export default {
  name: "Comparison",
  components: { ConfirmDialog },
  data() {
    return {
      isCollapsed: true,
      showConfirm: false,
      showConfirmClear: false,
      showConfirmCompare: false,
      pendingRemoveId: null
    };
  },
  computed: {
    ...mapGetters(["compareList"])
  },
  watch: {
    // "compareList.length"(newLen, oldLen) {
    //   if (newLen > oldLen) {
    //     this.isCollapsed = false;
    //   }
    // "compareList.length"() {
    //   this.isCollapsed = false;
    // }

  },
  // 监听兄弟组件发出的事件：类型不一致时展开对比栏
  mounted() {
    this.$root.$on('show-compare-panel', this.onShowComparePanel);
  },
  beforeDestroy() {
    this.$root.$off('show-compare-panel', this.onShowComparePanel);
  },
  methods: {
    toggleComparison() {
      this.isCollapsed = !this.isCollapsed;
    },
    // 兄弟组件触发：展开对比栏
    onShowComparePanel() {
      this.isCollapsed = false;
    },
    gotoSearch(){
      this.$router.push('/class/index/1');
    },
    close() {
      this.$store.commit("clearCompareGoods");
    },
    removeItem(id) {
      this.pendingRemoveId = id;
      this.showConfirm = true;
    },
    confirmRemove() {
      if (this.pendingRemoveId) {
        this.$store.commit("removeCompareGoods", this.pendingRemoveId);
        this.pendingRemoveId = null;
      }
      this.showConfirm = false;
    },
    clearAll() {
      this.$store.commit("clearCompareGoods");
      // this.showConfirmClear = true;
    },
    confirmClear() {
      this.$store.commit("clearCompareGoods");
      this.showConfirmClear = false;
    },
    goCompare() {
      if (this.compareList.length < 2) { 
        this.showConfirmCompare = true;
        return;
      }
      this.$router.push({ name: "goodscompare" });
    },
    gotoDetail(item) {
      const routeData = this.$router.resolve({
        name: "goodsinfo",
        params: { goodsid: item.id }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style scoped>
.comparison-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 346px;
  height: 100%;
  background: #fff;
  z-index: 2001;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}

.comparison-collapsed {
  position: fixed;
  top: 306px;
  right: 0;
  transform: translateY(-50%);
  background: #fff;
  color: #2655AE;
  padding: 8px 10px;
  width: 14px;
  border-radius: 4px 0 0 4px;
  cursor: pointer;
  z-index: 2000;
  font-size: 14px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
}

.comparison-header {
  height: 45px;
  line-height: 45px;
  padding: 0 8px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.compare-btn{
  width: 62px;
  height: 28px;
  font-size: 12px;
  line-height: 30px;
  text-align: center;
  border-radius: 40px;
}
.comparison-header .title {
  font-size: 14px;
  color: #303030;
  font-weight: 600;
}

.comparison-header .title .count {
  color: #ff6a00;
  font-style: normal;
  margin-left: 4px;
}

.comparison-header .actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.comparison-header .actions a {
  font-size: 14px;
  color: #ff6a00;
}

.comparison-header .actions .clear-btn {
  color: #999;
}

.comparison-header .actions .clear-btn:hover {
  color: #f56c6c;
}

.comparison-line .clear-btn:hover {
  color: #333;
}

.close-icon {
  font-size: 20px;
  color: #999;
  cursor: pointer;
  margin-left: 8px;
}

.close-icon:hover {
  color: #303030;
}

.comparison-body {
  flex: 1;
  overflow-y: auto;
  padding: 9px 5px;
  background-color: #f3f5f7;
}

.no-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 66px 20px;
  text-align: center;
}
.no-item img {
  width: 160px;
  margin-bottom: 22px;
}
.no-item p {
  font-size: 16px;
  color: #999;
  margin: 0 0 8px;
}
.no-item p:last-child {
  font-size: 16px;
  color: #FBB113;
  cursor: pointer;
  margin: 0;
}


.no-item img {
  width: 132px;
  margin-bottom: 20px;
}
.no-item p {
  font-size: 16px;
  color: #999;
  margin: 0 0 8px;
}
.no-item p:last-child {
  font-size: 16px;
  color: #FBB113;
  cursor: pointer;
  margin: 0;
}

.comparison-item {
  position: relative;
  display: flex;
  padding: 12px 0;
  margin-bottom: 9px;
  border: 1px solid #fff;
  align-items: flex-start;
  background-color: #fff;
  border-radius: 6px;
}

.comparison-item:last-child {
  border-bottom: none;
}

.comparison-item .item-img {
  width: 65px;
  height: 65px;
  margin-right: 12px;
  flex-shrink: 0;
  cursor: pointer;
  overflow: hidden;
  /* border: 1px solid #f0f0f0; */
  border-radius: 8px;
  margin: 9px 10px;

}

.comparison-item .item-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.comparison-item .item-info {
  flex: 1;
  overflow: hidden;
  padding-right: 4px;
}

.comparison-item .item-name {
  font-size: 16px;
  color: #303030;
  line-height: 20px;
  /* height: 40px; */
  overflow: hidden;
  /* display: -webkit-box; */
  /* -webkit-line-clamp: 2; */
  /* -webkit-box-orient: vertical; */
  cursor: pointer;
  margin: 4px 0 9px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
}



.comparison-item .item-desc {
  font-size: 14px;
  color: #999;
  line-height: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 0 10px;
}

.comparison-item .item-price {
  font-size: 16px;
  color: #FA1115;
  margin: 0;
}

.comparison-item .item-remove {
  position: absolute;
  bottom: 11px;
  right: 11px;
  font-size: 18px;
  color: #cccccc;
  cursor: pointer;
  display: none;
}

.comparison-item:hover .item-remove {
  display: block;
}

.comparison-item:hover {
  border: 1px solid #2655AE;
}

.compare-slide-right-enter-active,
.compare-slide-right-leave-active {
  transition: transform 0.3s ease;
}

.compare-slide-right-enter,
.compare-slide-right-leave-to {
  transform: translateX(100%);
}

/* 当收起时，将对比栏移出屏幕 */
.comparison-panel.collapsed {
  transform: translateX(100%);
}
</style>


// WEBPACK FOOTER //
// src/components/goods/Comparison.vue